import {useTranslation} from "react-i18next";
import {useEffect, useState, useRef, useContext} from "react";

import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import navs from "./navs";
import ButtonsActions from "views/utils/buttonsActions";
import axiApi from "ApiCaller";
import PreviewIsland from "./island/PreviewIsland";
import TableIsland from "./island/TableIsland";
import FormIsland from "./island/FormIsland";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import IslandModel from "site-apps/distribution/island/IslandModel";
import AuthContext from "context/AuthContext";
import IslandFilters from "./island/IslandFilters";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import {translations} from "./translations";
import useCustomTranslation from "core/customTranslation";
import OrderingModel from "components/ordering/OrderingModel";
import ConditionalRender from "../../components/ConditionalRender";
import ModalImportIslands from "./island/excel/ModalImportIslands";
import FileDownload from "core/utils/FileDownload";

const ViewIslands = () => {
    const {user} = useContext(AuthContext);

    const {t: _Tr} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tables");
    const {t: _Tc} = useCustomTranslation(translations);
    const bread = [
        {
            name: _Tr("labels.asset-management"),
            url: "/asset-management/",
            current: false,
        },
        {name: _Tr("labels.island"), current: true},
    ];
    const Alert = new SwalAlertClass({confirmButtonText: _Tf("labels.accept")});
    const paramsAlertDelete = {
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    };
    document.title = _Tr("labels.island");
    const AlertDelete = new SwalAlertChoice(paramsAlertDelete);
    const items = useRef(new ItemsModel());
    const [itemsShow, setItemsShow] = useState([]);
    const [item, setItem] = useState({...IslandModel});
    const [showPrev, setShowPrev] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [showImport, setShowImport] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [buttonsTB, setButtonsTB] = useState(() => {
        const buttonsAct = new ButtonsActions();
        buttonsAct.title = document.title;
        return buttonsAct;
    });
    const orderingRef = useRef(new OrderingModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);
    const params = useRef({zones: []});

    const headersTable = [
        {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("common.wastes"), attr: null, direction: null, active: false, disabled: true},
        {name: _Tt("common.devices"), attr: 2, direction: "asc", active: false},
        {name: _Tt("common.zones"), attr: 3, direction: "asc", active: false},
    ];

    useEffect(() => {
        const canEdit = user && (user.is_superuser || user.is_admin);

        const butAct = {...buttonsTB};
        butAct.title = _Tr("labels.island");

        butAct.edit.active = canEdit;
        butAct.edit.disabled = !canEdit || items.current.chosen.length !== 1;
        butAct.edit.onClick = onClickEdit;

        butAct.add.active = canEdit;
        butAct.add.disabled = !canEdit;
        butAct.add.onClick = onClickAdd;

        butAct.delete.active = canEdit;
        butAct.delete.disabled = !canEdit || items.current.chosen.length === 0;
        butAct.delete.onClick = onCLickDelete;

        butAct.export.active = true;
        butAct.export.disabled = false;
        butAct.export.onClick = onClickExport;

        butAct.import.active = canEdit;
        butAct.import.disabled = !canEdit;
        butAct.import.onClick = () => setShowImport(true);

        butAct.filter.active = true;
        butAct.filter.onClick = onClickFilter;
        butAct.filter.applied = Object.keys(filters.current.chosen).length > 0;
        setButtonsTB(butAct);

        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => fetchIslands();

        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => {
            applyFilters();
        };
        items.current.setItem = setItem;
        items.current.setShowPrev = (val) => {
            setShowPrev(val);
            if (val) {
                setShowForm(false);
            }
        };
        items.current.item = IslandModel;
        getIslands();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = {...buttonsTB};
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        applyFilters();
    };

    function onClickFilter() {
        const buttons = {...buttonsTB};
        buttons.filter.click = !buttonsTB.filter.click;
        buttons.counter = items.current.showed.length;
        setButtonsTB(buttons);
    }

    const itemsDelete = () => {
        let itemsDelete = items.current.getChosenIds();
        axiApi
            .delete("/api/distribution/islands/", {data: {ids: itemsDelete}})
            .then((resp) => {
                if (resp.status) {
                    items.current.showed = items.current.showed.filter((it) => !itemsDelete.includes(it.id));
                    items.current.all = items.current.all.filter((it) => !itemsDelete.includes(it.id));
                    setItemsShow([...items.current.showed]);
                    fetchIslands();
                    Alert.success(_Tc("alert.delete.success"), _Tc("alert.island.delete"));
                } else {
                    Alert.error(_Tf("errors.title"), _Tf("errors.server-error"));
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
                items.current.clearChosen();
                setSelectAll(false);
                setShowPrev(false);
            });
    };

    function onCLickDelete() {
        AlertDelete.question(_Tf("delete.title"), `Se eliminaran los ${items.current.chosen.length} seleccionados`).then(
            (resp) => {
                if (resp.isConfirmed) {
                    itemsDelete();
                }
            },
        );
    }

    const onClickEdit = () => {
        setShowPrev(false);
        setShowForm(true);
    };

    const onClickAdd = () => {
        setShowPrev(false);
        setItem({...IslandModel});
        setShowForm(true);
    };

    const onClickExport = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/islands/excel/export/", filters.current.chosen, {
                params: orderingRef.current.getParams(),
                responseType: "blob",
            })
            .then((resp) => FileDownload.fromBlob(resp.data, FileDownload.datedName("islas", "xlsx")))
            .catch((error) => {
                console.error("Error al exportar las islas:", error);
                Alert.error(_Tf("errors.title"), _Tc("alert.island.export.error"));
            })
            .finally(() => setIsLoading(false));
    };

    const fetchIslands = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.post("/api/distribution/islands/", filters.current.chosen, {
                params: pagerModelRef.current.paging.getParams(),
            });
            if (resp.data) {
                items.current.setShowed(resp.data.items);
                setItemsShow([...resp.data.items]);
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching islands:", error);
        }
    };

    const getIslands = async () => {
        setIsLoading(true);
        try {
            const resp = await axiApi.get("/api/distribution/islands/");
            if (resp.data) {
                items.current.showed = [...resp.data.items];
                setItemsShow(items.current.showed);
                params.current = resp.data.params;
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching islands:", error);
        }
    };

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/islands/", filters.current.chosen, {
                params: {
                    ...pagerModelRef.current.paging.getParams(),
                    ...orderingRef.current.getParams(),
                },
            })
            .then((resp) => {
                if (resp.data) {
                    items.current.setShowed(resp.data.items);
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.active = true;
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <IslandFilters filters={filters} show={buttonsTB.filter?.click} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="row">
                <div className="col">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableIsland
                            itemsShow={itemsShow}
                            items={items}
                            checkAll={selectAll}
                            setCheckAll={setSelectAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                <PreviewIsland item={item} showPrev={showPrev} />
                <ConditionalRender condition={showForm}>
                    <FormIsland
                        setShowForm={setShowForm}
                        showForm={showForm}
                        item={item}
                        setItemsShow={setItemsShow}
                        items={items}
                        itemsShow={itemsShow}
                        fetchIslands={fetchIslands}
                        params={params}
                    />
                </ConditionalRender>
                <ConditionalRender condition={showImport}>
                    <ModalImportIslands show={showImport} setShow={setShowImport} onImported={applyFilters} />
                </ConditionalRender>
            </div>
        </>
    );
};
export default ViewIslands;
